import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageUnauthorizedComponent } from './pages/page-unauthorized/page-unauthorized.component';
import { subMenuGuard } from './core/guards/sub-menu.guard';
import { withSubMenuId } from './core/utils/url-utils';

export const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: 'approve',
        loadChildren: () =>
          import(
            './features/work-permission/steps-to-approval/steps-to-approval.routes'
          ).then((r) => r.StepsToApprovalRoutes),
      },
      {
        path: 'permissions',
        loadChildren: () =>
          import(
            './features/work-permission/menu-access-schedule/menu-access-schedule.routes'
          ).then((r) => r.MenuAccessScheduleRoutes),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/user-routes.routes').then(
            (r) => r.UserRoutes
          ),
      },
      {
        path: 'departments',
        loadChildren: () =>
          import(
            './features/base-data-management/departments/departments-routes.routes'
          ).then((r) => r.DepartmentsRoutes),
      },
      {
        path: 'asset-acquisition-funds',
        loadChildren: () =>
          import(
            './features/base-data-management/asset-acquisition-funds/asset-acquisition-funds.routes'
          ).then((r) => r.AssetAcquisitionFundsRoutes),
      },
      {
        path: 'projects',
        loadChildren: () =>
          import(
            './features/base-data-management/project/projects.routes'
          ).then((r) => r.ProjectRoutes),
      },
      {
        path: 'materials',
        loadChildren: () =>
          import(
            './features/base-data-management/materials/materials-routes.routes'
          ).then((r) => r.MaterialsRoutes),
      },
      {
        path: 'assets',
        loadChildren: () =>
          import(
            './features/base-data-management/assets-management/assets-management.routes'
          ).then((r) => r.AssetsManagementRoutes),
      },
      {
        path: 'vehicles',
        loadChildren: () =>
          import(
            './features/base-data-management/vehicles/vehicles.routes'
          ).then((r) => r.VehiclesRoutes),
      },
      {
        path: 'land-buildings',
        loadChildren: () =>
          import(
            './features/base-data-management/land-buildings/land-buildings.routes'
          ).then((c) => c.LandBuildingsRoutes),
      },

      {
        path: 'all-org-inventory-controls',
        loadChildren: () =>
          import(
            './features/material-management-system/inventory-controls/all-org-material-inventory-control/all-org-inventory-controls.routes'
          ).then((r) => r.AllOrgInventorControlsRoutes),
      },
      {
        path: 'org-inventory-controls',
        loadChildren: () =>
          import(
            './features/material-management-system/inventory-controls/an-org-material-inventory-control/an-org-inventory-controls.routes'
          ).then((r) => r.AnOrgInventorControlsRoutes),
      },
      {
        path: 'notify-requirements',
        loadChildren: () =>
          import(
            './features/material-management-system/notify-requirements/notify-requirements.routes'
          ).then((r) => r.NotifyRequirements),
      },
      {
        path: 'material-inspection',
        loadChildren: () =>
          import(
            './features/material-management-system/material-inspaction/material-inspaction.routes'
          ).then((r) => r.MaterialInspectionRoutes),
      },
      {
        path: 'general-materials-requisition',
        loadChildren: () =>
          import(
            './features/material-management-system/material-requisition/material-requisition.routes'
          ).then((r) => r.MaterialRequisition),
      },
      {
        path: 'annual-audit',
        loadChildren: () =>
          import(
            './features/material-management-system/annual-audit/annual-audit.routes'
          ).then((r) => r.AnnualAudit),
      },
      {
        path: 'material-dashboard',
        loadComponent: () =>
          import(
            './features/material-management-system/materials-dashboard/materials-dashboard.component'
          ).then((c) => c.MaterialsDashboardComponent),
      },
      {
        path: 'material-report',
        loadComponent: () =>
          import(
            './features/material-management-system/summary-materials-report/summary-materials-report.component'
          ).then((c) => c.SummaryMaterialsReportComponent),
      },

      //ทะเบียนคุมครุภัณฑ์
      {
        path: 'asset-control',
        canActivateChild: [subMenuGuard],
        children: withSubMenuId(18, [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/assets-control.routes'
              ).then((r) => r.assetAcquisitionFundsRoutes),
          },
          {
            path: 'add-asset',
            loadChildren: () =>
              import(
                './features/assets-management-system/asset-add/add-asset.route'
              ).then((c) => c.assetAcquisitionFundsRoutes),
          },
        ]),
      },
      {
        path: 'asset-inspection',
        canActivateChild: [subMenuGuard],
        children: withSubMenuId(19, [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/assets-inspection/assets-inspection.routes'
              ).then((r) => r.asseInspectionRoutes),
          },
          {
            path: 'add-inspection',
            loadChildren: () =>
              import(
                './features/assets-management-system/assets-inspection/add-inspection/add-inspection.routes'
              ).then((r) => r.addAssetInspectionRoutes),
          },
          {
            path: 'assets-detail/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/assets-inspection/assets-inspection-detail/add-inspection-details.routes'
              ).then((r) => r.AssetsInspectionDetailComponent),
          },
        ]),
      },
      {
        path: 'internal-rent-asset-request',
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/internal-rent-asset-request/internal-rent-inspection.routes'
              ).then((r) => r.InternalRentAssetInspectionRoutes),
          },
          {
            path: 'add-rent-asset/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/internal-rent-asset-request/add-internal-rent-asset/add-internal-rent-inspection.routes'
              ).then((r) => r.addinternalrentInspectionRoutes),
          },
          {
            path: 'details-rent-asset/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/internal-rent-asset-request/details-internal-rent-asset/details-internal-rent-inspection.routes'
              ).then((r) => r.detailsinternalrentInspectionRoutes),
          },
          {
            path: 'lending-assets/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/internal-rent-asset-request/lending-internal-asset-request/lending-inspection-asset.routes'
              ).then((r) => r.lendingInternalRentAssetInspectionRoutes),
          },
          {
            path: 'lending-select-assets/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/internal-rent-asset-request/lending-select-internal-asset-request/lending-select-inspection-asset.routes'
              ).then((r) => r.lendingselectInternalRentAssetInspectionRoutes),
          },
          {
            path: 'lending-load-select-assets/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/internal-rent-asset-request/lending-select-internal-asset-request/lending-load-select-table/lending-load-select-inspection-asset.routes'
              ).then(
                (r) => r.lendloadingselectInternalRentAssetInspectionRoutes
              ),
          },
          {
            path: 'detail-lending-load-select/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/internal-rent-asset-request/detail-aftercart-lending-rent-asset/detail-aftercart-lending-select.routes'
              ).then(
                (r) => r.DetailLendLoadingSelectInternalRentInspectionRoutes
              ),
          },
          {
            path: 'add-external-rent-asset/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/internal-rent-asset-request/add-external-rent-asset/add-external-rent-asset.routes'
              ).then((r) => r.addExternalRentAssetInspectionRoutes),
          },
          // {
          //   path: 'Ex-load-select-assets/:id',
          //   loadChildren: () =>
          //     import(
          //       './features/assets-management-system/rent-request/internal-rent-asset-request/add-external-rent-asset/load-external-rent-asset/load-external-select-inspection-asset.routes'
          //     ).then((r) => r.ExloadingselectInternalRentAssetInspectionRoutes),
          // },
          {
            path: 'assets-detail/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/assets-inspection/assets-inspection-detail/add-inspection-details.routes'
              ).then((r) => r.AssetsInspectionDetailComponent),
          },
        ],
      },
      {
        path: 'government-rent-asset-request',
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/government-rent-asset-request/government-inspection.routes'
              ).then((c) => c.GovernmentRentAssetInspectionRoutes),
          },
          {
            path: 'add-internal-rent-government/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/government-rent-asset-request/add-internal-rent-asset/add-internal-rent-goverment.routes'
              ).then((r) => r.addgovermantrentInspectionRoutes),
          },
          {
            path: 'add-external-rent-government',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/government-rent-asset-request/add-external-rent-goverment/add-external-rent-goverment.routes'
              ).then((r) => r.addExternalGovermentAssetInspectionRoutes),
          },
          // {
          //   path: 'Ex-load-select-goverment/:id',
          //   loadChildren: () =>
          //     import(
          //       './features/assets-management-system/rent-request/government-rent-asset-request/add-external-rent-goverment/load-external-goverment/load-external-select-inspection-goverment.routes'
          //     ).then(
          //       (r) => r.ExloadingselectGovermentRentAssetInspectionRoutes
          //     ),
          // },
          {
            path: 'details-goverment-rent-government/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/government-rent-asset-request/details-goverment-rent-asset/details-goverment-rent-inspection.routes'
              ).then((r) => r.detailsgovermentrentInspectionRoutes),
          },
          {
            path: 'details-goverment-rent-after/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/government-rent-asset-request/details-gcerment-after-cart/detail-goverment-aftercart-select.routes'
              ).then((r) => r.DetailgovermentafterSelectRentInspectionRoutes),
          },
        ],
      },
      {
        path: 'farmer-rent-asset-request',
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/farmer-rent-asset-request/farmer-inspection.routes'
              ).then((c) => c.farmerRentAssetInspectionRoutes),
          },
          {
            path: 'add-internal-rent-farmer/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/farmer-rent-asset-request/add-farmer-rent-asset/add-internal-rent-farmer.routes'
              ).then((r) => r.addfarmerInspectionRoutes),
          },
          {
            path: 'add-external-rent-farmer',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/farmer-rent-asset-request/add-external-rent-farmer/add-external-rent-farmer.routes'
              ).then((r) => r.addExternalfarmerAssetInspectionRoutes),
          },
          // {
          //   path: 'Ex-load-select-farmer/:id',
          //   loadChildren: () =>
          //     import(
          //       './features/assets-management-system/rent-request/farmer-rent-asset-request/add-external-rent-farmer/load-external-farmer/load-external-select-inspection-farmer.routes'
          //     ).then((r) => r.ExloadingselectfarmerRentAssetInspectionRoutes),
          // },
          {
            path: 'details-farmer-rent-farmer/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/farmer-rent-asset-request/details-farmer-rent-asset/details-farmer-rent-inspection.routes'
              ).then((r) => r.detailsfarmertInspectionRoutes),
          },
          {
            path: 'details-farmer-rent-after/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/farmer-rent-asset-request/details-farmer-after-cart/detail-farmer-aftercart-select.routes'
              ).then((r) => r.DetailfarmerafterSelectRentInspectionRoutes),
          },
        ],
      },
      {
        path: 'borrowing',
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/land-management/borrowing/borrowing.routes'
              ).then((c) => c.BorrowingRoutes),
          },
        ],
      },
      {
        path: 'rent-asset-request',
        loadChildren: () =>
          import(
            './features/assets-management-system/rent-request/rent-asset-request/rent-asset-inspection.routes'
          ).then((c) => c.RentAssetInspectionRoutes),
      },
      {
        path: 'asset-report',
        loadComponent: () =>
          import(
            './features/assets-management-system/assets-reports/assets-reports.component'
          ).then((c) => c.AssetsReportsComponent),
      },
      {
        path: 'asset-dashboard',
        loadComponent: () =>
          import(
            './features/assets-management-system/asset-dashboard/asset-dashboard.component'
          ).then((c) => c.AssetDashboardComponent),
      },
      {
        path: 'land-control',
        loadChildren: () =>
          import(
            './features/land-management/land-registration/land-registration.routes'
          ).then((r) => r.LandRegistrationRoutes),
      },
      {
        path: 'building-registration',
        loadChildren: () =>
          import(
            './features/land-management/building-registration/building-registration.routes'
          ).then((r) => r.BuildingRegistrationRoutes),
      },
      {
        path: 'building-inspection',
        loadChildren: () =>
          import(
            './features/land-management/building-inspection/building-inspection.routes'
          ).then((r) => r.BuildingInspectionRoutes),
      },
      {
        path: 'building-annual-audit',
        loadChildren: () =>
          import(
            './features/land-management/building-annual-audit/building-annual-audit.routes'
          ).then((r) => r.BuildingAnnualAuditRoutes),
      },
      {
        path: 'building-inventory-return',
        loadChildren: () =>
          import(
            './features/land-management/building-inventory-return/building-inventory-return.routes'
          ).then((r) => r.BuildingReturnRoutes),
      },
      {
        path: 'land-building-dashboard',
        loadComponent: () =>
          import(
            './features/land-management/land-building-dashboard/land-building-dashboard.component'
          ).then((c) => c.LandBuildingDashboardComponent),
      },
      {
        path: 'land-building-report',
        loadComponent: () =>
          import(
            './features/land-management/land-building-report/land-building-report.component'
          ).then((c) => c.LandBuildingReportComponent),
      },
      {
        path: 'asset-government-vehicle',
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/assets-government-vehicle/assets-government-vehicle.routes'
              ).then((r) => r.assetGovernmentVehicleRoutes),
          },
        ],
      },
      {
        path: 'asset-withdraw',
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/assets-withdraw/assets-withdraw.routes'
              ).then((r) => r.AssetsWithdrawRoutes),
          },
        ],
      },
      {
        path: 'return-depot-asset',
        canActivateChild: [subMenuGuard],
        children: withSubMenuId(22, [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/return-depot.routes'
              ).then((c) => c.ReturnDepotRoutes),
          },
          {
            path: 'add-internal-depot-return/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/add-return-depot-asset/add-return-depot-asset.routes'
              ).then((r) => r.addDepotRoutes),
          },
          {
            path: 'add-internal-withdraw-return/:withdrawalId',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/add-return-withdraw-asset/add-return-withdraw-asset.routes'
              ).then((r) => r.addWithdrawRoutes),
          },
          {
            path: 'add-internal-distribute-return/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/add-return-distribute-asset/add-return-distribute-asset.routes'
              ).then((r) => r.addDistributeRoutes),
          },
          {
            path: 'add-select-items-depot',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/select-return-depot-asset/select-return-depot.routes'
              ).then((r) => r.SelectReturnDepotRoutes),
          },
          {
            path: 'load-items-cart/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/load-cart-depot-asset/load-cart-depot.routes'
              ).then((r) => r.LoadCartDepotRoutes),
          },
          {
            path: 'main-details-return-depot-items/:returnId',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/main-detail-return-depot-asset/main-detail-return-depot-asset.routes'
              ).then((r) => r.MainDetailReturnDepotInternalRentInspectionRoutes),
          },
          {
            path: 'details-return-depot-items/:returnId',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/detail-return-depot-asset/detail-return-depot-asset.routes'
              ).then((r) => r.DetailReturnDepotInternalRentInspectionRoutes),
          },
          {
            path: 'details-Withdraw-depot-items/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/detail-return-withdraw-asset/detail-return-withdraw-asset.routes'
              ).then((r) => r.DetailWithdrawDepotInternalRentInspectionRoutes),
          },
          {
            path: 'fix-gf-depot-items/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/fixgf-depot-asset/fixgf-return-asset.routes'
              ).then((r) => r.FixGFDepotInternalRentInspectionRoutes),
          },
          {
            path: 'details-distribute-depot-items/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/return-depot-asset/detail-return-distribute-asset/detail-return-distribute-asset.routes'
              ).then(
                (r) => r.DetaildistributeDepotInternalRentInspectionRoutes
              ),
          },
          {
            path: 'details-return-depot-items-after/:id',
            loadChildren: () =>
              import(
                './features/assets-management-system/rent-request/farmer-rent-asset-request/details-farmer-after-cart/detail-farmer-aftercart-select.routes'
              ).then((r) => r.DetailfarmerafterSelectRentInspectionRoutes),
          },
          {
            path: 'central-sales-form/:saleId',
            loadComponent: () =>
              import(
                './features/assets-management-system/return-depot-asset/add-central-sale-asset/add-central-sale-asset.component'
              ).then((c) => c.AddCentralSaleAssetComponent),
          },
          {
            path: 'central-sales-details/:saleId',
            loadComponent: () =>
              import(
                './features/assets-management-system/return-depot-asset/detail-central-sale-asset/detail-central-sale-asset.component'
              ).then((c) => c.DetailCentralSaleAssetComponent),
          },
          {
            path: 'regional-sales-form/:saleId',
            loadComponent: () =>
              import(
                './features/assets-management-system/return-depot-asset/add-regional-sale-asset/add-regional-sale-asset.component'
              ).then((c) => c.AddRegionalSaleAssetComponent),
          },
          {
            path: 'regional-sales-details/:saleId',
            loadComponent: () =>
              import(
                './features/assets-management-system/return-depot-asset/detail-regional-sale-asset/detail-regional-sale-asset.component'
              ).then((c) => c.DetailRegionalSaleAssetComponent),
          },
        ]),
      },
      {
        path: 'asset-annual-count',
        children: [
          {
            path: '',
            loadChildren: () =>
              import(
                './features/assets-management-system/assets-annual-count/assets-annual-count.routes'
              ).then((r) => r.AssetsAnnualCountRoutes),
          },
        ],
      },

      {
        path: 'correction-request',
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import(
                './features/correction-request/correction-request-record/correction-request-record.component'
              ).then((c) => c.CorrectionRequestRecordComponent),
          },
          {
            path: 'report',
            loadComponent: () =>
              import(
                './features/correction-request/correction-request-report/correction-request-report.component'
              ).then((c) => c.CorrectionRequestReportComponent),
          },
          {
            path: 'form',
            loadComponent: () =>
              import(
                './features/correction-request/correction-request-form/correction-request-form.component'
              ).then((c) => c.CorrectionRequestFormComponent),
          },
          {
            path: 'detail',
            loadComponent: () =>
              import(
                './features/correction-request/correction-request-detail/correction-request-detail.component'
              ).then((c) => c.CorrectionRequestDetailComponent),
          },
        ],
      },

      {
        path: 'user-manual',
        loadChildren: () =>
          import('./features/user-manual/user-manual.routes').then(
            (r) => r.UserManualRoutes
          ),
      }
    ],
  },
  { path: 'unauthorized', component: PageUnauthorizedComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' },
];
